import { BreadcrumbsHeader } from 'components/molecules/BreadcrumbsHeader';
import { Box, Card, CardContent, Grid, LinearProgress, MenuItem, Typography } from '@mui/material';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { useEffect, useState } from 'react';
import { DashboardService } from 'services/dashboard.service';
import { SelectInput } from 'components/Inputs/SelectInput';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const DashboardByPlan = () => {
  const [dashboardData, setDashboardData] = useState<any>(null);
  const [planId, setPlanId] = useState<string>('633ade6fd23307f1d6bea06f');
  const [plans, setPlans] = useState<any>();
  const [tutorPlans, setTutorPlans] = useState<number>(0);
  const [tutors, setTutors] = useState<number>(0);
  const [pets, setPets] = useState<number>(0);
  const [treatments, setTreatments] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);



  
  const getDashboardData = async () => {
    try {
      setIsLoading(true)
      setTutorPlans(0)
      setTutors(0)
      setPets(0)
      setTreatments(0)
      const plans = await DashboardService.getPlans();
      const dashboard = await DashboardService.getDashboardByPlan(planId);
      const {tutorPlanCount, tutorCount, petCount, treatmentCount} = await DashboardService.getDashboardNumbersByPlan(planId);
      setPlans(plans)
      setDashboardData(dashboard)
      setTutorPlans(tutorPlanCount)
      setTutors(tutorCount)
      setPets(petCount)
      setTreatments(treatmentCount)
      
    } catch (error) {
      
    } finally {
      setIsLoading(false)
    }
  
  }
  
  useEffect(()=>{
    getDashboardData();
  }, [planId])

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: 'Cadastro de Tutores nos Ultimos 12 meses',
      },
    },
  };
  
  const data = {
    labels: dashboardData?.labels,
    datasets: [
      {
        label: 'Assinaturas / Planos de Saúde',
        data: dashboardData?.tutorPlanData,
        borderColor: '#FBB45F',
        backgroundColor: '#FBB45F', maxWidth: 200,
      },

      {
        label: 'Cadastro de Pets',
        data: dashboardData?.petData,
        borderColor: 'blue',
        backgroundColor: 'blue',
      },

      {
        label: 'Cadastro de Tutores',
        data: dashboardData?.tutorData,
        borderColor: 'red',
        backgroundColor: 'red',
      },

      {
        label: 'Atendimentos Realizados',
        data: dashboardData?.treatmentData,
        borderColor: 'purple',
        backgroundColor: 'purple',
      },
    ],
  };

  return (
    <Grid container spacing={2} justifyContent='center' alignItems='center'>
       <BreadcrumbsHeader
          items={[
            { title: 'Dashboard' },
            { title: 'Informações por Planos' },
          ]}
        />
      <Grid container direction='row' justifyContent='center' alignItems='center' display='flex' gap={2}>
        <Card style={{backgroundColor: '#FBB45F', width: 200, height: 100}}>
          <CardContent>
            <Typography color='white' fontWeight={700} fontSize={20} align='center'>Tutores</Typography>
            <Typography color='white' fontWeight={800} fontSize={20} align='center'>{tutors}</Typography>
          </CardContent>
        </Card>

        <Card style={{ backgroundColor: '#FBB45F', width: 200, height: 100}}>
          <CardContent>
            <Typography color='white' fontWeight={700} fontSize={20} align='center'>
              {planId === '633ade6fd23307f1d6bea06f' ? 'Assinaturas' : 'Plano de Saúde'}
            </Typography>
            <Typography color='white' fontWeight={800} fontSize={20} align='center'>{tutorPlans}</Typography>
          </CardContent>
        </Card>

        <Card style={{ backgroundColor: '#FBB45F', width: 200, height: 100}}>
          <CardContent>
            <Typography color='white' fontWeight={700} fontSize={20} align='center'>Atendimentos</Typography>
            <Typography color='white' fontWeight={800} fontSize={20} align='center'>{treatments}</Typography>
          </CardContent>
        </Card>

        <Card style={{ backgroundColor: '#FBB45F', width: 200, height: 100}}>
          <CardContent>
            <Typography color='white' fontWeight={700} fontSize={20} align='center'>Vidas</Typography>
            <Typography color='white' fontWeight={800} fontSize={20} align='center'>{pets}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid container xs={12} justifyContent={'center'}>
        <Grid container xs={8} mt={3} mb={3} ml={3} >
          <SelectInput
            name="plan"
            id="_id"
            label="Selecione o plano"
            onChange={(event)=> { setPlanId(event.target.value as string) }}
            value={planId}
            defaultValue={planId}
          >
            {plans?.map((plan: any) => (
              <MenuItem key={plan._id} value={plan._id}>
                {plan.title}
              </MenuItem> 
            ))}
        </SelectInput>
      </Grid>
        <Box sx={{ width: '100%' }} hidden={!isLoading} >
          <LinearProgress />
        </Box>
        <Line style={{visibility: isLoading ? 'hidden' : 'visible'}} options={options} data={data} />
      </Grid>
    </Grid>
  );
};
